export const toEnglishDigits = (str) =>
str.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));


export function parseLocalizedNumber(str) {
    if (!str) return NaN;
  
    // 1) تبدیل اعداد فارسی و عربی به انگلیسی
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    const arabicDigits = "٠١٢٣٤٥٦٧٨٩";
  
    let normalized = str.replace(/[۰-۹]/g, d => persianDigits.indexOf(d))
                        .replace(/[٠-٩]/g, d => arabicDigits.indexOf(d));
  
    // 2) حذف کاماهای فارسی و انگلیسی
    normalized = normalized.replace(/[.,،]/g, match => (match === '.' ? '.' : ''));
  
    // 3) تبدیل به عدد
    return Number(normalized);
  };
  